import React, { Component } from 'react';

import BaseModal from './BaseModal';

class Modal extends Component {
    static instance;

    constructor(props) {
        super(props);
        Modal.instance = this;
        this.state = {
            show: false,
            title: '',
            body: null,
            showConfirm: true,
            showCancel: false,
            callBack: null,
            modal: null,
            class: ''
        }
    }

    render() {
        return (
            <BaseModal
                show={this.state.show}
                title={this.state.title}
                onConfirm={(this.state.showConfirm ? Modal.onConfirm : null)}
                onCancel={(this.state.showCancel ? Modal.onCancel : null)}
                onConfirmText="OK"
                onCancelText="Cancelar"
                onHide={(this.state.showCancel ? Modal.onCancel : Modal.onCancel)}
                className={this.state.class}
                {...this.state?.modal}>
                {this.state.body}
            </BaseModal>);
    }
    static show(title, body, showConfirm = true, showCancel = false, callBack = null, modalProps = null, className = '') {
        Modal.instance.__show(title, body, showConfirm, showCancel, callBack, modalProps, className);
    }

    static onConfirm(params = null) {
        Modal.instance.__onConfirm(params);
    }

    static onCancel() {
        Modal.instance.__onCancel();
    }

    __show(title, body, showConfirm, showCancel, callBack, modal, className) {
        this.setState({ title, body, show: true, showConfirm, showCancel, callBack, modal, class: className });
    }
    __onConfirm(params) {
        this.state.callBack && this.state.callBack(params);
        this.setState({ title: '', body: null, show: false, showConfirm: false, showCancel: false });
    }
    __onCancel() {
        this.setState({ title: '', body: null, show: false, showConfirm: false, showCancel: false });
    }
}

export default Modal;